module.exports = __webpack_public_path__ + "static/media/liveshows.6eceb049.jpg";